import { render, staticRenderFns } from "./black.vue?vue&type=template&id=b3c1cf6c&scoped=true&"
import script from "./black.vue?vue&type=script&lang=js&"
export * from "./black.vue?vue&type=script&lang=js&"
import style0 from "./black.vue?vue&type=style&index=0&id=b3c1cf6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c1cf6c",
  null
  
)

export default component.exports